import "./SummaryBar.css";
import SummaryMapTile from "./SummaryMapTile";

// Format how the data is displayed within the summary bar
function formatDisplayDate(dateValue) {
  if (!dateValue) {
    return "All time";
  }

  const date = new Date(`${dateValue}T00:00:00`);

  if (Number.isNaN(date.getTime())) {
    return dateValue;
  }

  return new Intl.DateTimeFormat("en-AU", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  }).format(date);
}

function SummaryBar({
  // Set up Summary Bar structure
  startDate,
  endDate,
  acUsed = 0,
  acTotal = 0,
  dcUsed = 0,
  dcTotal = 0,

  locations = [],
  selectedLocations = [],
  chargerType = "Both",

  onPreviousMonth,
  onNextMonth,
  onViewMap
}) {
  const periodText =
    !startDate && !endDate
      ? "All available data"
      : `${formatDisplayDate(startDate)} to ${formatDisplayDate(
          endDate
        )}`;

  return (
    <section className="summary-card">
      <div className="summary-card-header">
        <div>
          <span className="summary-eyebrow">
            Current selection
          </span>

          <h2>Dashboard summary</h2>
        </div>

        <span className="summary-period">
          {periodText}
        </span>
      </div>

      <div className="summary-content">
        <div className="summary-stat summary-stat-ac">
          <span className="summary-stat-label">
            AC outlets used
          </span>

          <strong>
            {acUsed}
            <span> / {acTotal}</span>
          </strong>

          <small>
            {acUsed === 1
              ? "outlet used in this period"
              : "outlets used in this period"}
          </small>
        </div>

        <div className="summary-stat summary-stat-dc">
          <span className="summary-stat-label">
            DC outlets used
          </span>

          <strong>
            {dcUsed}
            <span> / {dcTotal}</span>
          </strong>

          <small>
            {dcUsed === 1
              ? "outlet used in this period"
              : "outlets used in this period"}
          </small>
        </div>

        <SummaryMapTile
          locations={locations}
          selectedLocations={selectedLocations}
          chargerType={chargerType}
          onViewMap={onViewMap}
        />

        <div className="summary-navigation">
          <button
            type="button"
            className="summary-button summary-button-secondary"
            onClick={onPreviousMonth}
            disabled={!startDate}
          >
            ← Previous month
          </button>

          <button
            type="button"
            className="summary-button summary-button-primary"
            onClick={onNextMonth}
            disabled={!startDate}
          >
            Next month →
          </button>
        </div>
      </div>
    </section>
  );
}

export default SummaryBar;